"use client";

import clsx from "clsx";
import dynamic from "next/dynamic";

import loading from "../../../public/images/lotties/loading.json";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import { useTranslationDetector } from "../../hooks/useTranslationDetector";

// Lottie is only rendered when isVisible is true (overlay never shows on SSR),
// so defer loading lottie-react + lottie-web until the first loading state.
// This removes ~77 KB gzip from every page's initial bundle.
const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

const LoadingOverlay = ({
  isVisible = false,
  customComponent = null,
  className = "",
  overlayClassName = "",
}) => {
  const t = useTranslationDetector();
  useLockBodyScroll(isVisible);

  if (!isVisible) return null;

  if (customComponent) {
    return customComponent;
  }

  return (
    <div
      className={clsx(
        "fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm",
        overlayClassName,
      )}
    >
      <div
        className={clsx(
          "flex flex-col items-center justify-center gap-3",
          className,
        )}
      >
        <div className="h-20 w-20">
          <Lottie animationData={loading} loop={true} autoplay={true} />
        </div>
        <span className="font-semibold">{t("common.pleasewait")}</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
